import types from './types';
import { resourceReducerGenerator } from '../../../utils';

export default resourceReducerGenerator('nslds', types);
